import React from "react";
import {DatePollInfo} from "../../models/DatePollInfo";
import AttendType from "../../models/AttendType";
import '../../styles/UserIcon.scss';
import {Box, Grid} from "@mui/material";

interface UserIconWrapperProps {
    datePollInfo: DatePollInfo
}

const UserIconWrapper: React.FC<UserIconWrapperProps> = ({datePollInfo}) => {
    const attendDatePollInfo = datePollInfo.pollData.filter((memberAndAttendType) => memberAndAttendType.attendType === AttendType.ATTEND);
    const notSureDatePollInfo = datePollInfo.pollData.filter((memberAndAttendType) => memberAndAttendType.attendType === AttendType.NOT_SURE);

    return (
        <>
            <Box height={'4px'}/>
            <Grid container spacing={0.2} justifyContent={'center'}>
                {attendDatePollInfo
                    .map((memberAndAttendType, index) => (
                        <Grid item xs={4} key={index}>
                            <UserIcon key={index} src={memberAndAttendType.member.profileImage}
                                      attendType={memberAndAttendType.attendType}/>
                        </Grid>
                    ))}
            </Grid>
            {(attendDatePollInfo.length !== 0 && notSureDatePollInfo.length !== 0) && <Box height={'4px'}/>}
            <Grid container spacing={0.2} justifyContent={'center'}>
                {notSureDatePollInfo
                    .map((memberAndAttendType, index) => (
                        <Grid item xs={4} key={index}>
                            <UserIcon key={index} src={memberAndAttendType.member.profileImage}
                                      attendType={memberAndAttendType.attendType}/>
                        </Grid>
                    ))}
            </Grid>
        </>
    );
}

const UserIcon: React.FC<{ src: string, attendType: AttendType }> = ({ src, attendType }) => {
    const renderContent = () => {
        switch (attendType) {
            case AttendType.ATTEND:
                return <img src={src} className="user-icon" style={{ outline: '2px solid #38D59C' }} />
            case AttendType.NOT_SURE:
                return (
                    <div className="user-icon-not-sure-wrapper">
                        <img src={src} className="user-icon" style={{ outline: '2px solid #555555', opacity: 0.5 }} />
                        <div className="icon-overlay">?</div>
                    </div>
                );
            default:
                return <></>
        }
    }
    return (
        <div className="user-icon-wrapper">
            {renderContent()}
        </div>
    )
}

export default UserIconWrapper;